<template>
    <base-info/>
</template>

<script>
    import BaseInfo from "_private/components/super/systemSetting/organizationManage/BaseInfo";

    export default {
        components: {
            BaseInfo
        }
    };
</script>
